import { render, staticRenderFns } from "./columns_list.vue?vue&type=template&id=d0ad2dfa&"
import script from "./columns_list.vue?vue&type=script&lang=js&"
export * from "./columns_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d0ad2dfa')) {
      api.createRecord('d0ad2dfa', component.options)
    } else {
      api.reload('d0ad2dfa', component.options)
    }
    module.hot.accept("./columns_list.vue?vue&type=template&id=d0ad2dfa&", function () {
      api.rerender('d0ad2dfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/crud/columns_list.vue"
export default component.exports